import { saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

export default function ProductMenu({ menu, langKey, info, activeTab = 'product', callTab, hideTabs = [''], hasOffres, buyLink = '', isBuyInCallback }: any) {
    const { useLang, useState, useEffect, useRouter, gtm, Link } = useGlobal();
    const { t } = useLang(langKey);
    const { pathname, locale, query } = useRouter();
    const { t: s } = useLang('shared.product.menu');
    const { title, menus = [], buyText = '' } = menu;
    const curItem = Array.isArray(title) ? title?.find((item: any) => item?.url?.split('?')[0] === `/${locale}${pathname}`) : title;
    const otherItems = Array.isArray(title) ? title?.filter((item: any) => item?.url !== `/${locale}${pathname}`) : [];
    const [top, setTop] = useState(0);
    const [toggle, setToggle] = useState(false);
    const [over, setOver] = useState('left');
    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    const defaultMenus = [
        {
            text: s('tab_product'),
            key: 'product',
        },
        {
            text: s('tab_bundles'),
            key: 'bundles',
        },
        {
            text: s('tab_support'),
            key: 'support',
        },
        {
            text: s('tab_specs'),
            key: 'specs',
        },
        {
            text: s('tab_media'),
            key: 'media',
        },
    ];

    let tabs_static = menus?.length > 0 ? menus : defaultMenus;

    if (hasOffres) {
        tabs_static = [
            {
                // text: s('tab_product'),
                text: 'Offers',
                key: 'offers',
            },
            ...tabs_static,
        ];
    }

    const [tabs, setTabs] = useState(tabs_static?.filter((tab: any) => !hideTabs.includes(tab?.key)));

    if (locale === 'jp' && pathname === '/delta-pro-ultra' && !tabs.find((tab) => tab.key === 'casestudy')) {
        tabs.push({
            text: '導入事例',
            key: 'casestudy',
            url: 'https://blog.ecoflow.com/jp/delta-pro-ultra-power-switch-kit-case/',
        });
    }

    const handleScroll = (e: any) => {
        const { scrollLeft, scrollWidth } = e.target;
        // 允许5px的范围误差
        if (scrollWidth - scrollLeft - 5 < window?.innerWidth) {
            return setOver('right');
        }
        if (scrollLeft < 5) {
            return setOver('left');
        }
        return setOver('');
    };

    const handleCallTab = (tab: string, btn?: string) => {
        // filter 返回的是数组,必须要使用[0]把它取出来
        const arrayA = tabs_static?.filter((item: any) => {
            return item?.key === tab;
        });
        const itemA = arrayA[0] || {};
        const text = itemA?.text;
        if (btn !== 'buy') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_navigation',
                navigation_name: text || tab,
                product_name: pathname === '/delta-pro-3-portable-power-station' ? 'EcoFlow DELTA Pro 3' : locale === 'au' ? t(title) : t(curItem?.product),
            });
        }
        if (tab === 'offers' && pathname === '/delta-pro-3-portable-power-station') {
            callTab(tab);
            if (!['offers', 'product'].includes(activeTab)) {
                return setTimeout(() => {
                    const target = document.querySelector('.dp3-teaser-B') as HTMLDivElement;
                    return target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 0);
            } else {
                const target = document.querySelector('.dp3-teaser-B') as HTMLDivElement;
                return target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
        if (tab === 'casestudy') {
            return window.open(`https://blog.ecoflow.com/jp/delta-pro-ultra-power-switch-kit-case/`, '_blank');
        }
        if (window?.innerWidth < 768) {
            const scrollTarget = document.querySelector('.product-menu .menu-content.h5 .menu-tabs-box .menu-tabs') as HTMLElement;
            if (['support', 'specs', 'media'].includes(tab)) {
                scrollTarget.scrollLeft = scrollTarget.scrollWidth - window?.innerWidth > 0 ? scrollTarget.scrollWidth - window?.innerWidth : 0;
            } else {
                scrollTarget.scrollLeft = 0;
            }
        }
        callTab(tab);
    };

    const handleBuyNow = () => {
        // if (pathname === '/delta-pro-ultra-daily-use' || query.back === '/delta-pro-ultra-daily-use') {
        //     try {
        //         const product =
        //             pathname === '/delta-pro-ultra-daily-use'
        //                 ? 'EcoFlow DELTA Pro Ultra Hassle-Free Kit (Time-Of-Use)'
        //                 : 'EcoFlow DELTA Pro Ultra Whole-Home Backup Power';
        //         gtm.push({
        //             event: 'uaEvent',
        //             event_name: 'checkout',
        //             button_name: `${s('buy_now')}_${product}`,
        //         });
        //     } catch (e) {
        //         console.error(e);
        //     } finally {
        //         window.open(`https://${locale}.ecoflow.com/cart/${info?.variantId}:1?channel=buy_button`, '_blank');
        //     }
        // } else {

        if (isBuyInCallback) {
            // 是否点击了buy,并且在页面中跳转,可以跳product,也可以跳 bundles
            handleCallTab('buy', 'buy');
        } else if (buyLink) {
            const self = buyLink.indexOf(window?.location?.pathname) > -1;
            const way = self ? '_self' : '_blank';
            const link_href = saveCookieForShopify(buyLink, locale);
            if (self) {
                // 第一种： 后台配置了url链接, 且url与本页面一致（锚点定位），则当前页面定位至锚点处
                if (activeTab !== 'product') {
                    handleCallTab('product');
                    setTimeout(() => {
                        window.open(link_href, way);
                    }, 200);
                } else {
                    window.open(link_href, way);
                }
            } else {
                // 第二种： 后台配置了url链接, 但url与本页面不一致，则打开新页面
                window.open(link_href, way);
            }
        } else {
            // 第三种： 后台没有配置链接，则默认跳转至bundle的tab中
            handleCallTab('bundles', 'buy');
        }

        // AU DP3 首销售期 BUY NOW 要求埋点 product_navigation
        if (pathname === '/delta-pro-3-portable-power-station' && locale === 'au') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_navigation',
                navigation_name: 'Buy Now',
                product_name: 'EcoFlow DELTA Pro 3',
            });
        } else if (pathname === '/delta-pro-ultra' && ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: 'EcoFlow DELTA Pro Ultra',
                position: 'Top',
            });
        } else if (locale === 'jp') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: 'EcoFlow DELTA Pro 3',
                position: 'Top',
            });
        } else if (locale === 'au') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_navigation',
                navigation_name: 'Buy Now',
                product_name: t(title),
            });
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'jump_button',
                position: 'Top',
                button_name: buyText || s('buy_now'),
                url: 'None',
            });
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resize = () => {
                const header = document.querySelector('.ecoflow-frame-header') as HTMLDivElement;
                const bar = document.querySelector('.announcement-bar ') as HTMLElement;
                const productBar = document.querySelector('.product-announcement-bar ') as HTMLElement;
                let topH = 0;
                if (header) {
                    const computedHeaderStyle = window.getComputedStyle(header);
                    const positionHeaderValue = computedHeaderStyle.getPropertyValue('position');
                    if (positionHeaderValue === 'sticky') {
                        topH += header?.offsetHeight;
                    }
                }
                if (bar) {
                    const computedBarStyle = window.getComputedStyle(bar);
                    const positionBarValue = computedBarStyle.getPropertyValue('position');
                    if (positionBarValue === 'sticky') {
                        topH += bar?.offsetHeight;
                    }
                }
                if (productBar) {
                    const computedProductBarStyle = window.getComputedStyle(productBar);
                    const positionProductBarValue = computedProductBarStyle.getPropertyValue('position');
                    if (positionProductBarValue === 'sticky') {
                        topH += productBar?.offsetHeight;
                    }
                }
                setTop(topH - 1);
            };
            setTimeout(() => {
                resize();
            }, 1000);
            //window.addEventListener('resize', resize);
            //return () => window.removeEventListener('resize', resize);
        }
    }, []);

    return (
        <section className={`product-menu ok ${css['product-menu']}`} style={{ top: `${top}px` }}>
            <div className="menu-content pc">
                {Array?.isArray(title) ? (
                    <ul className="menu-header">
                        {title?.map((item: any, k: number) => (
                            <li className={`title ${item?.url?.split('?')[0] === `/${locale}${pathname}` ? 'active' : ''}`} key={k}>
                                {t(item?.product) && (
                                    <>
                                        {k !== 0 && <span className="line"></span>}
                                        <Link
                                            href={item?.url}
                                            target={String(item?.url).startsWith('http') ? '_blank' : '_self'}
                                            className="title-link"
                                            rel="noreferrer"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'product_page_switch',
                                                position: pathname === '/smart-home-panel-2' ? 'EcoFlow Smart Home Panel 2' : 'EcoFlow DELTA Pro Ultra',
                                                button_name: t(item?.product),
                                            }}
                                        >
                                            {t(item?.product)}
                                        </Link>
                                    </>
                                )}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <span className="title active">{t(title)}</span>
                )}
                <div className="menu-right">
                    <ul className="menu-tabs">
                        {tabs?.map((tab: any, k: number) => (
                            <li
                                className={`tab ${activeTab === tab?.key ? 'active' : ''}`}
                                key={k}
                                onClick={() => activeTab !== tab?.key && handleCallTab(tab?.key)}
                            >
                                {tab?.text}
                            </li>
                        ))}
                    </ul>
                    {!hideTabs.includes('buy') && locale !== 'ph' && (
                        <button className="buy-now" onClick={handleBuyNow}>
                            {buyText || s('buy_now')}
                        </button>
                    )}
                </div>
            </div>
            <div className="menu-content h5">
                <div className="menu-header">
                    <div className="header-title" onClick={() => setToggle(!toggle)}>
                        {Array.isArray(title) ? (
                            <>
                                <span className="product-name">{t(curItem?.product)}</span>
                                {!(isEU && pathname === '/delta-pro-ultra') && (
                                    <svg
                                        className={`prouduct-svg ${toggle ? 'rotate' : ''}`}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="13"
                                        viewBox="0 0 12 13"
                                        fill="none"
                                    >
                                        <path
                                            d="M10.1543 4.80762L6.1543 8.80762L2.1543 4.80762"
                                            stroke="white"
                                            strokeWidth="1.05"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                )}
                            </>
                        ) : (
                            <span className="header-title">{t(title)}</span>
                        )}
                    </div>
                    {!hideTabs.includes('buy') && locale !== 'ph' && (
                        <button className="buy-now" onClick={handleBuyNow}>
                            {buyText || s('buy_now')}
                        </button>
                    )}
                </div>
                <div className={`menu-tabs-box ${over}`}>
                    <ul className="menu-tabs" onScroll={handleScroll}>
                        {tabs?.map((tab: any, k: number) => (
                            <li
                                className={`tab ${activeTab === tab?.key ? 'active' : ''}`}
                                key={k}
                                onClick={() => activeTab !== tab?.key && handleCallTab(tab?.key)}
                            >
                                <a href={tab?.url} target={String(tab?.url).startsWith('http') ? '_blank' : '_self'} className="tab-link" rel="noreferrer">
                                    {tab?.text}
                                </a>
                            </li>
                        ))}
                        {toggle && (
                            <ul className="other-products">
                                {otherItems?.map((item: any, k: number) => (
                                    <li className="other-item" key={k}>
                                        <a
                                            href={item?.url}
                                            target={String(item?.url).startsWith('http') ? '_blank' : '_self'}
                                            className="other-link"
                                            rel="noreferrer"
                                        >
                                            {t(item?.product)}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </ul>
                </div>
            </div>
        </section>
    );
}
